import { getXoom } from '../xoom';
import { initPopups as init } from '../../components/legacy/tooltips';

const initPopups = () => {
  const xoom = getXoom();
  xoom.ui.Popups = init();
  return xoom;
};

export default initPopups;
